<div class="offers">
  <!--
  <h3> Rendez vous ({{keepOffers == null ? 0 : keepOffers!.length}})</h3>
  <button *ngIf="(appointments == undefined || appointments.length === 0 )"
    class="cta-button"  mat-button (click)="openAppointmentDialog('', undefined);$event.stopPropagation()">
    Nouvelle<mat-icon>add</mat-icon>
  </button> -->

  @if (enableNew) {
    <button mat-button class="cta-button-{{businessLine!.toLowerCase()}}" (click)="openKeepOfferDialog('');$event.stopPropagation()">
      Nouvelle<mat-icon>add</mat-icon>
    </button>
  }

  @if (keepOffers == undefined || keepOffers.length === 0) {
    <h6>
      Aucune offre en cours
    </h6>
  }

  @if (!(keepOffers == undefined || keepOffers.length === 0 )) {
    <div class="offer-list">
      @for (offer of keepOffers; track offer; let i = $index) {
        <div class="offer">
          <div class="summary">
            <!-- <b>[{{ (conversation.participants[0] === null)? 'EXT' : conversation.participants[0] }}]</b>
            <h4 *ngIf="objectSource===ObjectSource.DEALER"> {{offer.make}} {{offer.model}} {{offer.version}} </h4>  -->
            <h4 class="summary-details"><mat-icon>location_on</mat-icon> {{offer.city}} - {{offer.country}} </h4>
            <h4 class="summary-details"><mat-icon>person</mat-icon> Vendeur: <b>{{offer.providerBusinessName}}</b></h4>
            <br />
            <button  class="simple-button-{{offer.businessLine.toLowerCase()}}"  mat-button (click)="goToOfferPage(offer.offerId, offer.businessLine);$event.stopPropagation()">
              Aller à l'offre<mat-icon>open_in_new</mat-icon>
            </button>
          </div>
          <div class="content">
            @if (offer.businessLine === CarBusinessLine.BUY) {
              <span>
                <h4>
                  {{moneyFormat(""+offer.buyPrice.amount)}} {{offer.buyPrice.currency}}
                  <button style="display: inline;" matButton class="simple-button-buy"  mat-button (click)="openPriceHistoryDialog(offer.buyPriceHistory, offer.businessLine);$event.stopPropagation()">
                    <mat-icon>timeline</mat-icon>
                  </button>
                </h4>
              </span>
            }
            @if (offer.businessLine === CarBusinessLine.RENT) {
              <span>
                <h4> {{moneyFormat(""+offer.rentDayRate.amount)}} {{offer.rentDayRate.currency}}/J
                  <button style="display: inline;" matButton class="simple-button-rent"  mat-button (click)="openPriceHistoryDialog(offer.rentDayRateHistory, offer.businessLine);$event.stopPropagation()">
                    <mat-icon>timeline</mat-icon>
                  </button>
                </h4>
              </span>
            }
            <h6> Titre: {{offer.offerTitle}}</h6>
            <h6> Description: {{offer.offerDescription}}</h6>
            <h6>Services fournis: @for (serv of offer.servicesProvided; track serv; let i = $index) {
              <b>{{getServiceTypeTitle(serv)}},&nbsp;</b>
            }</h6>
            <h6>Catégories prestations: @for (cat of offer.jobCategories; track cat; let i = $index) {
              <b>{{getJobCategoryTitle(cat)}},&nbsp;</b>
            }</h6>
            <h6>Spécialités (marques): @for (mk of offer.specialtyMakes; track mk; let i = $index) {
              <b>{{mk}},&nbsp;</b>
            }</h6>
            <h6>Localisation: <b>{{offer.geoLocation?.latitude}}, {{offer.geoLocation?.longitude}}</b></h6>
            <h6> Date debut: {{dateFormat(offer.offerStartDate)}}</h6>
            <h6> Date fin: {{dateFormat(offer.offerEndDate)}}</h6>
            <!--
            <h6> Date création: {{dateFormat(offer.created)}}</h6>
            <h6> Dernière mise a jour: {{dateFormat(offer.lastUpdated)}}</h6>  -->
            <div class="action-buttons">
              <!--
              <button  *ngIf="!(offer.offerPosted)"
                class="simple-button-{{offer.businessLine.toLowerCase()}}"  mat-button (click)="deleteOffer(offer.offerId);$event.stopPropagation()">
                <mat-icon>delete</mat-icon>
              </button>
              -->
              @if (!(offer.offerClosed)) {
                <button
                  class="simple-button-{{offer.businessLine.toLowerCase()}}"  mat-button (click)="openKeepOfferDialog(offer.offerId);$event.stopPropagation()">
                  Editer <mat-icon>edit</mat-icon>
                </button>
              }
              <button [disabled]="offer.offerClosed"
                class="simple-button-{{offer.businessLine.toLowerCase()}}"  mat-button (click)="toggleOfferPostedStatus(offer.offerId);$event.stopPropagation()">
                {{ offer.offerPosted ? 'Dépublier' : 'Publier' }} <mat-icon [style.color]="! offer.offerPosted ? '#008000':'#ff0000'"> {{ offer.offerPosted  ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              <button
                class="simple-button-{{offer.businessLine.toLowerCase()}}"  mat-button (click)="toggleOfferClosedStatus(offer.offerId);$event.stopPropagation()">
                {{ offer.offerClosed ? 'Ouvrir' : 'Fermer' }} <mat-icon [style.color]="offer.offerClosed ? '#008000':'#ff0000'"> {{ offer.offerClosed  ? 'public_off' : 'public' }}</mat-icon>
              </button>
            </div>
          </div>
          <div>
            <h3>Prestations</h3>
            @if ((offer.jobs.length >= 0)) {
              <app-jobs
                [objectSource]="objectSource"
                [offerId] = "$safeNavigationMigration(offer?.offerId)!"
                [enableNew]="true"
                >
              </app-jobs>
            }
          </div>
        </div>
      }
    </div>
  }
</div>